import {acquireToken, getGroupsFromToken} from "./MsalUtils";
import {App_Conf} from "./core/app_conf";

export const pacingUserRedirect = async (msalInstance?: any, tokenGroups?: string[]) => {
    try {
        const groups = tokenGroups ?? getGroupsFromToken(await acquireToken(msalInstance));
        if (Array.isArray(groups) && groups.length === 1 && groups[0] === App_Conf.PACING_USER_GROUP) {
            window.location.replace(`${window.location.origin}/pacingmodel/`);
            return true;
        }
    } catch (e) {
        // Fail silently and allow app to continue
    }
    return false;
};